jQuery(document).ready(function ($) {
    var animating = false;
    $(window).resize(function () {
        setupDoorBackground();
    });
    setupDoorBackground();
    function setupDoorBackground()
    {
        $('.door.today').each(function () {
            var parentOffset = $(this).closest('.advent-outer').offset();
            var doorOffset = $(this).offset();
            // calculate the parent's offset to the image. ASSUMES IMAGE IS 1920 TO AVOID LOADING IT
            var imageWidth = 1920;
            var parentWidth = $(this).closest('.advent-outer').outerWidth();
            var offset = (imageWidth - parentWidth) / 2;
            console.log(doorOffset.top,parentOffset.top);
            $(this).find('.door-content').css({
                'background-image': $(this).closest('.advent-outer').css('background-image'),
                'background-repeat': 'no-repeat',
                'background-position': -1 * Math.round(doorOffset.left - parentOffset.left + offset + 4) + 'px ' + -1 * Math.round(doorOffset.top - parentOffset.top + 4) + 'px',
            });
        });
        $('.door.today').each(function () {
            var parentOffset = $(this).closest('.advent-outer').offset();
            var doorOffset = $(this).offset();
            // calculate the parent's offset to the image. ASSUMES IMAGE IS 1920 TO AVOID LOADING IT
            var imageWidth = 1920;
            var parentWidth = $(this).closest('.advent-outer').outerWidth();
            var offset = (imageWidth - parentWidth) / 2;
            console.log(doorOffset.top,parentOffset.top);
            $(this).find('.door-content').css({
                'background-image': $(this).closest('.advent-outer').css('background-image'),
                'background-repeat': 'no-repeat',
                'background-position': -1 * Math.round(doorOffset.left - parentOffset.left + offset + 4) + 'px ' + -1 * Math.round(doorOffset.top - parentOffset.top + 4) + 'px',
            });
        });
    }

    $(window).on("popstate", function (event) {
        // if the state is the page you expect, pull the name and load it.
        window.location.href = event.target.location.href;
    });
    $(document).on('click','[data-action="jump-today"]',function (e) {
        e.preventDefault();
        $('html').css('scroll-behavior','initial');
        var offset = 0;
        if ($('#wpadminbar').length) {
            offset = $('#wpadminbar').outerHeight();
        }
        $('body,html').animate({
            scrollTop: $('.today:eq(0)').offset().top - offset
        }, 1000, function () {
            $('html').css('scroll-behavior','');
            $('.today:eq(0)').addClass('opening');
            setTimeout(function () {
                $('.today:eq(0)').trigger('click');
            },1000);
        });
    }).on('click', '.door', function (e) {
        e.preventDefault();
        if (animating) {
            return;
        }
        if (!$(this).hasClass('future') && $(this).find('.content-expired').length == 0) {
            animating = true;

            $(this).addClass('opening');

            var $newContent = $('<div class="new-content-outer" style="position: absolute;top: 0;left:0;"><div class="container"><div class="new-content"><h1>Error</h1><h2>Could not find that day...</h2></div></div></div>');
            var targetHref = $(this).attr('href');
            var $that = $(this);
            $.ajax(targetHref, {
                success: function (data) {
                    $newContent = $(data).find('#new-content-outer');
                },
                complete: function () {
                    var $newContentClone = $newContent.clone();
                    $that.closest('.advent-outer').after($newContent);
                    $newContent.css('opacity', 0);
                    // video comment below
                    $that.append('<div class="zoom-content-contain"></div>');
                    $that.find('.zoom-content-contain:eq(0)').append($newContentClone);
                    var scale = Math.round(10000 * $that.outerWidth() / $newContent.outerWidth()) / 10000;
                    var height = $newContent.outerHeight();
                    var width = $newContent.find('.container').outerWidth();
                    var doorHeight = $that.outerHeight() - 8;
                    var doorWidth = $that.outerWidth() - 8;
                    if (height * scale < doorHeight) {
                        height = doorHeight / scale;
                    }
                    if (width * scale < doorWidth) {
                        width = doorWidth / scale;
                    }
                    $newContentClone.css({
                        width: width,
                        height: height,
                        transform: 'scale(' + scale + ',' + scale + ')'
                    });
                    zoom.to({
                        element: $that[0],
                        pan: false,
                        callback: function () {
                            history.pushState({urlPath: targetHref}, "", targetHref);
                            setTimeout(function () {
                                animating = false;
                                var $hideBody = $('<div style="position:absolute;top:0;left:0;right:0;bottom:0;z-index:200000;opacity:0;background:#000;" />');
                                $('body').append($hideBody);
                                $('.calendar').animate({
                                    filter: 'blur(30px)'
                                });
                                $hideBody.animate({
                                    opacity: 1
                                });
                                $hideBody.animate({
                                    opacity: 1
                                }, 250, function () {
                                    $('html').css('scroll-behavior','initial');
                                    $('html,body').animate({
                                        scrollTop: 0
                                    },5,function () {
                                        $('html').css('scroll-behavior','');
                                        $('body').css({
                                            transition: '',
                                            'transform-origin': '',
                                            transform: ''
                                        });
                                        $that.closest('.calendar').remove();
                                        // video comment from here
                                        $hideBody.animate({
                                            opacity: 0
                                        }, 250, function () {
                                            $hideBody.remove();
                                        });
                                        // video comment to here
                                    });
                                });
                                $newContent.css({
                                    position: 'relative',
                                }).animate({
                                    opacity: 1
                                }, 500);
                            }, 1000); //  video remove timeout
                        }
                    });
                }
            });
        }
    });
});